/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { defineMessages } from 'react-intl';

import { fetchGet } from 'FetchAPIs';
import { I18NError } from 'Utils';
import { HIERARCHY_ITEM_STATUS } from 'dataConstants';

const baseMetaURL = '/api/meta';

const messages = defineMessages({
  entityTypeError: 'Error loading device types.',
  entityTypeLogsError: 'Error loading logs for the device type.',
});

export function getEntityTypesAPI(status = HIERARCHY_ITEM_STATUS.ACTIVE) {
  return fetchGet(`${baseMetaURL}/entityType`, null, { status })
    .then(response => response)
    .catch(error => {
      throw new I18NError(messages.entityTypeError, error);
    });
}

/** fetch a single entity type */
export function getEntityType(entityTypeName) {
  return fetchGet(`${baseMetaURL}/entityType/${entityTypeName}`)
    .then(response => response)
    .catch(error => {
      throw new I18NError(messages.entityTypeError, error);
    });
}
